import { ICON_NAMES } from "../../../elements/Icon";
import { isValueValid } from "./isValueValid";
export var getIcon = function getIcon(value) {
  var isClearable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return isValueValid(value) && isClearable ? ICON_NAMES.CLOSE : ICON_NAMES.CARET_DOWN;
};